/** Стрелки сортировки в заголовке колонки и номер уровня при сортировке по нескольким колонкам. */
const DataTableSortMark = ({
    active,
    dir,
    index,
    multi,
}: {
    active: boolean;
    dir: 'asc' | 'desc' | false;
    index: number;
    multi: boolean;
}) => (
    <span className="dtb__sort">
        <span className="dtb__sort-arrows">
            <svg viewBox="0 0 24 24" style={{ opacity: active && dir === 'asc' ? 1 : 0.4 }} aria-hidden>
                <path d="M12 6l5 6H7z" fill="currentColor" />
            </svg>
            <svg viewBox="0 0 24 24" style={{ opacity: active && dir === 'desc' ? 1 : 0.4 }} aria-hidden>
                <path d="M12 18l-5-6h10z" fill="currentColor" />
            </svg>
        </span>
        {multi && active && <span className="dtb__sort-idx">{index}</span>}
    </span>
);

export default DataTableSortMark;
